import React from 'react';

import { LoginForm } from "../../components/LoginForm";
import { Header } from "../../components/Header";

import { LoginRoleContent } from "../../content/login";
import { USER_ROLE } from "../../constants/";
import LOGIN_CONTENT from "../../content";

import '../Landing/landing.styles.scss';
import { USER_ROLE_ENUM } from "../../types";

interface LoginProps {
  userRole: USER_ROLE_ENUM;
}

export const Login: React.FC<LoginProps> = ({ userRole }) => {
  let content: LoginRoleContent = LOGIN_CONTENT.student;
  switch(userRole) {
    case USER_ROLE.student:
      content = LOGIN_CONTENT.student;
      break;
    case USER_ROLE.teacher:
      content = LOGIN_CONTENT.teacher;
      break;
    case USER_ROLE.admin:
      content = LOGIN_CONTENT.admin;
      break;
  }
  // const navigate = useNavigate();
  //
  // useEffect(() => {
  //   axios.get(`http://localhost:8000/login/${userRole}`, {
  //     withCredentials: true, // if using cookies for auth
  //   })
  //     .then(response => {
  //       console.log('LOGIN REACT', response.data)
  //
  //       const { auth, userId } = response.data;
  //
  //       if (auth && !!userId.length) {
  //
  //         console.log('LOGIN REACT IN')
  //         navigate(content.PAGE_URL);
  //       }
  //       console.log('landing');
  //     })
  //     .catch(err => {
  //       console.log('err.response?.data', err.response?.data);
  //     });
  // }, []);

  return (
    <>
      <Header goBack={true} logOut={false} />
      <main className="LandingContainer">
        {userRole === USER_ROLE.student &&
          <div className="ImageContainer">
            <img src="/images/child-login.webp" alt="Child at the desk" className="Image"/>
          </div>
        }
        <LoginForm
          content={content}
          userRole={userRole}
        />
      </main>
    </>
  )
};
